export const planKeys = {
  all: ['plans'] as const,
  lists: () => [...planKeys.all, 'list'] as const,
  list: () => [...planKeys.lists()] as const,
  details: () => [...planKeys.all, 'detail'] as const,
  detail: (planId: string) => [...planKeys.details(), planId] as const,
  pricingImpact: (planId: string) => [...planKeys.all, 'pricing-impact', planId] as const,
  priceMigrations: (planId: string) => [...planKeys.all, 'price-migrations', planId] as const,
};
